import { Box, keyframes } from '@mui/material';

const a1 = keyframes`
  0% { transform: translateY(0) translateX(0) scale(1); opacity: 0.7; }
  50% { transform: translateY(-40px) translateX(8px) scale(1.4); opacity: 0.4; }
  100% { transform: translateY(-80px) translateX(-5px) scale(1.8); opacity: 0; }
`;

const a2 = keyframes`
  0% { transform: translateY(0) translateX(0) scale(1); opacity: 0.6; }
  50% { transform: translateY(-40px) translateX(-10px) scale(1.3); opacity: 0.35; }
  100% { transform: translateY(-80px) translateX(5px) scale(1.6); opacity: 0; }
`;

const a3 = keyframes`
  0% { transform: translateY(0) translateX(0) scale(1); opacity: 0.65; }
  50% { transform: translateY(-40px) translateX(6px) scale(1.35); opacity: 0.38; }
  100% { transform: translateY(-80px) translateX(-8px) scale(1.7); opacity: 0; }
`;

const a4 = keyframes`
  0% { transform: translateY(0) translateX(0) scale(1); opacity: 0.7; }
  50% { transform: translateY(-40px) translateX(-7px) scale(1.45); opacity: 0.42; }
  100% { transform: translateY(-80px) translateX(6px) scale(1.75); opacity: 0; }
`;

const a5 = keyframes`
  0%, 100% { box-shadow: 0 0 15px rgba(255, 215, 0, 0.4), 0 0 25px rgba(255, 165, 0, 0.2); }
  50% { box-shadow: 0 0 20px rgba(255, 215, 0, 0.5), 0 0 30px rgba(255, 165, 0, 0.3); }
`;

export const SpecialEffect = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '70px',
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '50px',
          height: '32px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%)',
          borderRadius: '4px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 -2px 4px rgba(139, 69, 19, 0.3), inset 0 2px 3px rgba(255, 255, 150, 0.4)',
          border: '1px solid #D4A044',
          zIndex: 1,
          animation: `${a5} 2s ease-in-out infinite`,
          '&::before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: `
              radial-gradient(circle at 15% 25%, rgba(255, 235, 150, 0.6) 0%, transparent 8%),
              radial-gradient(circle at 35% 20%, rgba(255, 235, 150, 0.5) 0%, transparent 6%),
              radial-gradient(circle at 55% 28%, rgba(255, 235, 150, 0.55) 0%, transparent 7%),
              radial-gradient(circle at 75% 22%, rgba(255, 235, 150, 0.5) 0%, transparent 6%),
              radial-gradient(circle at 85% 30%, rgba(255, 235, 150, 0.45) 0%, transparent 5%),
              radial-gradient(circle at 20% 60%, rgba(255, 235, 150, 0.5) 0%, transparent 7%),
              radial-gradient(circle at 45% 65%, rgba(255, 235, 150, 0.55) 0%, transparent 8%),
              radial-gradient(circle at 70% 58%, rgba(255, 235, 150, 0.5) 0%, transparent 6%),
              radial-gradient(circle at 88% 62%, rgba(255, 235, 150, 0.48) 0%, transparent 5%),
              radial-gradient(circle at 12% 45%, rgba(255, 235, 150, 0.45) 0%, transparent 5%),
              radial-gradient(circle at 62% 42%, rgba(255, 235, 150, 0.5) 0%, transparent 6%)
            `,
            borderRadius: '4px',
            pointerEvents: 'none'
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '3px',
            left: '3px',
            right: '3px',
            height: '40%',
            background: 'linear-gradient(180deg, rgba(255, 255, 200, 0.5) 0%, transparent 100%)',
            borderRadius: '3px 3px 0 0',
            pointerEvents: 'none'
          }
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '-5px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '4px',
          height: '4px',
          zIndex: 2
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(220, 220, 220, 0.7) 0%, rgba(180, 180, 180, 0.3) 100%)',
            filter: 'blur(4px)',
            animation: `${a1} 2.5s ease-out infinite`,
            animationDelay: '0s'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(210, 210, 210, 0.6) 0%, rgba(170, 170, 170, 0.25) 100%)',
            filter: 'blur(3px)',
            animation: `${a2} 2.8s ease-out infinite`,
            animationDelay: '0.3s'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: '11px',
            height: '11px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(215, 215, 215, 0.65) 0%, rgba(175, 175, 175, 0.28) 100%)',
            filter: 'blur(3.5px)',
            animation: `${a3} 2.6s ease-out infinite`,
            animationDelay: '0.6s'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: '13px',
            height: '13px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(218, 218, 218, 0.7) 0%, rgba(178, 178, 178, 0.3) 100%)',
            filter: 'blur(4px)',
            animation: `${a4} 2.7s ease-out infinite`,
            animationDelay: '0.9s'
          }}
        />
      </Box>
    </Box>
  );
};
